// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__s261K","avatarPic":"Avatar_avatarPic__6lCwZ","ring":"Avatar_ring__RlR9z","rotate":"Avatar_rotate__BaP-7"};